import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import {API} from '../../shared/constants/api.constants';
import {AuthServerProvider} from '../../shared/auth/auth-jwt.service';
import {Item} from './item.model';
import { ResponseWrapper } from '../../shared';
import * as $ from 'jquery';

@Injectable()
export class ItemService {

    private resourceUrl = API.host + 'invoices/print-view';
	private resourceReleaseInfoUrl = API.host + 'InvoicePortal/InvoicePortal-release-info';
    private resourcePreviewUrl = API.host + 'InvoicePortal/InvoicePortal-preview';
    private resourceGetFooterInfo = API.host + 'InvoicePortal/get-footer-info';
    private resourceGetCompanyInfo = API.host + 'companies';
    private resourcetemplatesUrl = API.host + 'InvoicePortal/InvoicePortal-templates';
    private resourceVerify = API.host + 'InvoicePortal/VerifyXml';
    private resourceGetHeaderInfo = API.host + 'InvoicePortal/get-header-info';

    constructor(private http: Http, private authServerProvider: AuthServerProvider) {
    }

    getTemplates(companyId: number): Observable<ResponseWrapper> {
        return this.http.get(this.resourcetemplatesUrl + '/' + companyId )
            .map((res: Response) => this.convertResponse(res));
    }

    private convertResponse(res: Response): any {
        if (!res || !res.json) {
            throw 'Invalid Code';
        }
        const jsonResponse = res.json().data;
        return new ResponseWrapper(res.headers, jsonResponse, res.status);
    }

    getPdf(id: number, callback) {
        $('body').addClass('loading');
        try {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', this.resourceUrl + '/' + id);
            //xhr.open('GET', this.resourceSwitchUrl + '/' + id);
            xhr.responseType = 'arraybuffer';
            xhr.setRequestHeader('X-Authorization-Token', this.authServerProvider.getToken());
            xhr.onload = function() {
                if (xhr.status === 200) {
                    const blob = new Blob([xhr.response], {
                        type: 'application/pdf'
                    });

                    const url = window.URL.createObjectURL(blob);
                    callback(url);

                    $('body').removeClass('loading');
                }
            };

            xhr.onerror = function() {
                $('body').removeClass('loading');
            };

            xhr.send();
        } catch (error) {
            console.error('error', error);
        }
    }

    formatItemFromServer(itemFromServer) {
        return itemFromServer;
    }

    getCompanyInfo(id: number){
        return this.http.get(`${this.resourceGetCompanyInfo}/${id}`).map((res: Response) => {
            if (!res || !res.json) {
                throw 'Invalid Code';
            }

            return res.json().data;
        });
    }

    getReleaseInfo(id: number): Observable<any> {
        return this.http.get(`${this.resourceReleaseInfoUrl}/${id}`).map((res: Response) => {
            if (!res || !res.json) {
                throw 'Invalid Code';
            }

            return res.json().data;
        });
    }

    findPreview(id: number): Observable<Item> {
        return this.http.get(`${this.resourcePreviewUrl}/${id}`).map((res: Response) => {
            if (!res || !res.json) {
                throw 'Invalid Code';
            }
            return res.json().data;
        });
    }

    getFooterInfo(): Observable<any> {
        return this.http.get(`${this.resourceGetFooterInfo}`).map((res: Response) => {
            if (!res || !res.json) {
                throw 'Invalid Code';
            }
            return res.json().data;
        })
    }
    
	public uploadFile(fileToUpload: File) {
		const _formData = new FormData();
		//_formData.append('file', fileToUpload, fileToUpload.name);   
		_formData.append(fileToUpload.name, fileToUpload);
		return this.http.post(this.resourceVerify, _formData).map((res: Response) => {
            if (!res || !res.json) {
                throw res;
            }

            return res.json().data;
        });
	}

    getHeaderInfo(): Observable<any> {
        return this.http.get(`${this.resourceGetHeaderInfo}`).map((res: Response) => {
            if (!res || !res.json) {
                throw 'Invalid Code';
            }
            return res.json().data;
        })
    }
}
